import styled from 'styled-components';

import theme from '@theme/FolxTheme';

export const EditButtonWrapper = styled.div`
	position: relative;
	flex-shrink: 0;
`;
